import { Component, Input } from '@angular/core';
import { Image } from 'src/app/people/models/image';
import { CloudinaryConfig } from 'src/app/shared/models/config/cloudinaryConfig';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'lineup-avatar',
  templateUrl: 'avatar.component.html',
  styleUrls: ['avatar.component.scss'],
  standalone: false
})
export class AvatarComponent {
  @Input()
  image: Image;
  @Input()
  thumbnail: boolean;
  @Input()
  darkened: boolean;
  @Input()
  noDefaultAvatar: boolean;
  @Input()
  selected: boolean;

  private circular_transformation: string = 'w_400,h_400,c_crop,g_face,r_max';
  private small_size_transformation: string = 'w_40,h_40';
  private large_size_transformation: string = 'w_125,h_125';
  private darkened_transformation: string = 'e_brightness_hsb:-50';

  constructor(private appConfigService: AppConfigService) {}

  shouldShowAvatar(): boolean {
    return (
      this.image !== undefined &&
      this.image !== null &&
      this.image.id !== null &&
      this.image.id !== undefined &&
      this.image.id !== '' &&
      !this.selected
    );
  }

  getImageUrl() {
    return this.thumbnail ? this.getSmall() : this.getLarge();
  }

  getSmall() {
    return `${this.publicImageUrl}${this.circular_transformation}/${this.small_size_transformation}/${this.image.id}.png`;
  }

  getLarge() {
    return `${this.publicImageUrl}${this.circular_transformation}/${this.large_size_transformation}/${this.image.id}.png`;
  }

  getDarkened() {
    return `${this.publicImageUrl}${this.circular_transformation}/${this.large_size_transformation}/${this.darkened_transformation}/${this.image.id}.png`;
  }

  getDefaultImageUrl() {
    const size_transformation = this.thumbnail
      ? this.small_size_transformation
      : this.large_size_transformation;
    const environmentPath = this.cloudinaryConfig.upload.upload_preset.replace('_preset', '');

    return `${this.publicImageUrl}${this.circular_transformation}/${size_transformation}/${environmentPath}/defaultAvatar.png`;
  }

  private get publicImageUrl(): string {
    return this.cloudinaryConfig.publicImageUrl;
  }

  private get cloudinaryConfig(): CloudinaryConfig {
    return this.appConfigService.config.cloudinary;
  }
}
